import { render, staticRenderFns } from "./goodsList.vue?vue&type=template&id=47fe941a"
import script from "./goodsList.vue?vue&type=script&lang=ts"
export * from "./goodsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports